// 鲸智云
export const cloudsApi = process.env.REACT_APP_API_URL;
// 管理端
export const manageApi = process.env.REACT_APP_MANAGE_API_URL_API;
// 连山
export const lianshanApi = process.env.REACT_APP_LIAN_SHAN_API_URL_API;

// 用于邀请链接
export const inviteUserHttps = `${process.env.REACT_APP_JZY_URL}/welcome`;
